// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedRole: null,
  availableUsersRole: [],
  actions: []
}

const roles = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_ROLES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_ROLE':
      return { ...state }
    case 'DELETE_ROLE':
      return { ...state }
    case 'ADD_USER_ROLE':
      return { ...state }
    case 'DELETE_USER_ROLE':
      return { ...state }
    case 'GET_ROLE':
      return { ...state, selectedRole: action.selectedRole }
    case 'EDIT_ROLE':
      return { ...state }
    case 'EDIT_PERMISSIONS':
      return { ...state }
    case 'GET_AVAILABLE_USERS_ROLE':
      return { ...state, availableUsersRole: action.availableUsersRole }
    case 'GET_ACTIONS':
      return { ...state, actions: action.actions }
    default:
      return { ...state }
  }
}
export default roles
